// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jsvyb{flex:1;justify-content:start;align-items:center}.H2HBq{width:100%;aspect-ratio:16/9}.Lw1Xk{width:100%;aspect-ratio:16/9;display:flex;align-items:center;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Jsvyb`,
	"videoWrapper": `H2HBq`,
	"loaderWrapper": `Lw1Xk`
};
export default ___CSS_LOADER_EXPORT___;
